import { Text } from '@moia-dev/pace-web'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { fetchSendResetPasswordCode } from '../api'
import { GetSupportChannelByEmail } from '../components/GetSupportChannelByEmail'
import { PublicAppViewContentLayout } from '../components/PublicAppViewContentLayout'
import { ForgotPasswordForm } from './ForgotPasswordForm'

export const ForgotPasswordView = ({ isMobile }: { isMobile: boolean }) => {
  const navigate = useNavigate()
  const handleRedirect = (url: string) => navigate(url)
  const [errorEmail, setError] = useState('')

  const handleValidationError = (email: string) => () => setError(email)

  const handleSubmitForm = ({ email = '' }) =>
    fetchSendResetPasswordCode(email, handleRedirect, () =>
      handleValidationError(email),
    )

  const { t } = useTranslation()

  return (
    <PublicAppViewContentLayout
      title={t('loginView_forgotPassword_title')}
      isMobile={isMobile}
    >
      {errorEmail && (
        <Text size="md" color="critical">
          {t('loginView_validationErrorMessage')}{' '}
          <GetSupportChannelByEmail email={errorEmail} />
        </Text>
      )}
      <ForgotPasswordForm onSubmit={handleSubmitForm} isMobile={isMobile} />
    </PublicAppViewContentLayout>
  )
}
